export const VERSION = '4.7.0';
// export const BASE_URL = 'https://edunix-api.beetronix.com';
export const BASE_URL = 'https://api.daralfikr.edunixsystem.com';
// export const BASE_URL = 'https://api.albayan-schools.com';
